module.exports = __webpack_public_path__ + "static/media/things-to-do.a4bcf375.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/manage-redesign/things-to-do.svg
// module id = 965
// module chunks = 71